import React from 'react'
import {
  Table,
  TableBody,
  TableRow,
  TableHeader,
  TableHeaderColumn,
  TableRowColumn
} from 'material-ui/Table'
import IconMenu from 'material-ui/IconMenu'
import IconButton from 'material-ui/IconButton'
import MoreVertIcon from 'material-ui/svg-icons/navigation/more-vert'
import MenuItem from 'material-ui/MenuItem'
import { CardTitle } from 'material-ui/Card'

import { formatDateTime, formatCurrency } from '../../../../formatters'
import ResourceDisplay from '../../../resource-display'
import VoidTransactionDialog from './void-transaction-dialog'

class ListRefunds extends React.Component<any, any> {
  constructor (props) {
    super(props)
    this.state = {
      openDialog: false,
      selectedRefund: null
    }
  }

  openVoidDialog = selectedRefund => {
    this.setState({
      openDialog: true,
      selectedRefund
    })
  }

  closeDialog = () => {
    this.setState({
      openDialog: false,
      selectedRefund: null
    })
  }

  render () {
    return (
      <div>
        <CardTitle title='Refunds' />
        <Table selectable={false}>
          <TableHeader adjustForCheckbox={false} displaySelectAll={false}>
            <TableRow>
              <TableHeaderColumn>
                Date
              </TableHeaderColumn>
              <TableHeaderColumn>
                Amount
              </TableHeaderColumn>
              <TableHeaderColumn>
                Provider
              </TableHeaderColumn>
              <TableHeaderColumn>
                Reference #
              </TableHeaderColumn>
              <TableHeaderColumn>
                Reason
              </TableHeaderColumn>
              <TableHeaderColumn />
              <TableHeaderColumn style={{ menuColumn: { width: '50px' } }} />
            </TableRow>
          </TableHeader>
          <TableBody displayRowCheckbox={false}>
            {this.props.refunds.map(refund => (
              <TableRow key={refund.id}>
                <TableRowColumn>
                  {formatDateTime(refund.refund_date)}
                </TableRowColumn>
                <TableRowColumn>
                  {formatCurrency(refund.amount)}
                </TableRowColumn>
                <TableRowColumn>
                  {
                    refund.payment_provider_id &&
                      <ResourceDisplay
                        display='name'
                        filters={{
                          id: refund.payment_provider_id
                        }}
                        path='admin/payment_providers'
                      />
                  }
                </TableRowColumn>
                <TableRowColumn>
                  {refund.reference_number}
                </TableRowColumn>
                <TableRowColumn>
                  {refund.reason}
                </TableRowColumn>
                <TableRowColumn>
                  {refund.voided_at ? 'VOIDED' : ''}
                </TableRowColumn>
                <TableRowColumn style={{ menuColumn: { width: '50px' } }}>
                  <IconMenu
                    iconButtonElement={<IconButton><MoreVertIcon /></IconButton>}
                  >
                    <MenuItem
                      primaryText={refund.voided_at ? 'Revalidate' : 'Void'}
                      onClick={() => this.openVoidDialog(refund)}
                    />
                  </IconMenu>
                </TableRowColumn>
                <VoidTransactionDialog
// @ts-ignore
                  open={this.state.openDialog}
                  isVoid={refund.voided_at}
                  transaction={this.state.selectedRefund}
                  transactionLabel='refund'
                  closeDialog={this.closeDialog}
                  onRefundUpdated={this.props.onRefundUpdated}
                />
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    )
  }
}

export default ListRefunds
